// src/components/Modals/UpdateUsernameModal.jsx
import React, { useState } from 'react';

const UpdateUsernameModal = ({ currentUsername, onClose, onSave }) => {
  const [username, setUsername] = useState(currentUsername || '');

  const handleSubmit = () => {
    if (username.trim()) {
      onSave(username.trim());
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.heading}>Update Username</h2>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={styles.input}
          placeholder="Enter new username"
        />
        <div style={styles.buttons}>
          <button onClick={handleSubmit} style={styles.save}>Save</button>
          <button onClick={onClose} style={styles.cancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: '#1e1e1e',
    padding: '2rem',
    borderRadius: '12px',
    width: '300px',
    boxShadow: '0 0 20px rgba(0,0,0,0.5)',
  },
  heading: {
    fontFamily: 'VT323',
    color: '#FAFF00',
    fontSize: '1.75rem',
    marginBottom: '1rem',
    textAlign: 'center',
  },
  input: {
    width: '100%',
    padding: '0.5rem',
    border: '1px solid #555',
    backgroundColor: '#2a2a2a',
    color: '#fff',
    fontFamily: 'VT323',
    fontSize: '1.25rem',
    borderRadius: '6px',
    marginBottom: '1rem',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  save: {
    backgroundColor: '#00ffff',
    color: '#000',
    padding: '0.5rem 1rem',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontFamily: 'VT323',
  },
  cancel: {
    backgroundColor: '#444',
    color: '#fff',
    padding: '0.5rem 1rem',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontFamily: 'VT323',
  },
};

export default UpdateUsernameModal;
